import { appLocalStorage } from '@/app/shared/commonURLs';

let MedicalRecordsBaseURL = appLocalStorage.MedicalRecordsURL;
let MedicalRecordsBaseOdataURL = appLocalStorage.MedicalRecordsOdataURL;

export class uRls {
   constructor() {
       this.MedicalRecordsServiceList = MedicalRecordsURls();
   }
}

const MedicalRecordsURl = new uRls();

export { MedicalRecordsURl };

function MedicalRecordsURls() {

   var services = {};

    services["GetMergeRequestsCount"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeRequest/GetMergeRequestsCount',
    }

    services["IsPatientHasPendingRequests"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeRequest/IsPatientHasPendingRequests',
    }

    services["GetPatientMergeConfiguration"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MPIConfiguration/GetPatientMergeConfiguration',
    }

    services["GetPatientNewMergeVisits"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeRequest/GetPatientNewMergeVisits',
    }

    services["GetMergeRequests"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseOdataURL + 'MergeRequestOData?',
    }

    services["GetMergeReasonDDL"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeReason/GetMergeReasonDDL',
    }

    services["AddNewPatientMerge"] = {
        Method: 'POST',
        URL: MedicalRecordsBaseURL + 'MergeRequest/AddNewPatientMerge',
    }

    services["GetMergeResponses"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseOdataURL + 'MergeResponseOData?',
    }

    services["GetMergeRequestPatientDetails"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseOdataURL + 'MergeRequestPatientDetailOData?',
    }

    services["SingleRequestConfirm"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/SingleRequestConfirm?',
    }

    services["GetMergeCancelReasonDDL"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeCancelReason/GetMergeCancelReasonDDL',
    }

    services["CancelDraftMergeRequest"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/CancelDraftMergeRequest',
    }

    services["CancelPendingMergeRequest"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/CancelPendingMergeRequest',
    }
    
    services["GetMergeRequestPatientVisits"] = {
        Method: 'GET',
        URL: MedicalRecordsBaseURL + 'MergeRequest/GetMergeRequestPatientVisits',
    }
    
    services["UndoConfirm"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/UndoConfirm',
    }
     
    services["UndoCancelPending"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/UndoCancelPending',
    }
    
    services["UndoCancelDraft"] = {
        Method: 'PUT',
        URL: MedicalRecordsBaseURL + 'MergeRequest/UndoCancelDraft',
    }

    return services;
}




